import { render, staticRenderFns } from "./single-time.vue?vue&type=template&id=2706e8e9"
import script from "./single-time.vue?vue&type=script&lang=ts"
export * from "./single-time.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports